import React from 'react';
import styled from '@emotion/styled';
import { Box, Flex } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import Button from '@/components/Button';
import { PackageOptionProps } from '../PackageOption/types';
import { PackageOptionCard } from './components';
import PackageOptionContent from './components/PackageOptionContent';
import PackageOptionHeading from './components/PackageOptionHeading';

const StyledBox = styled(Flex)`
  outline-width: ${themeGet('components.packageOption.borderWidth')};
  border-radius: ${themeGet('components.packageOption.borderRadius')};
  outline-offset: -${themeGet('components.packageOption.borderWidth')};
  outline-style: solid;
  outline-color: ${({ selected }: { selected: boolean }) =>
    themeGet(
      selected
        ? `components.packageOption.selected.borderColor`
        : `components.packageOption.default.borderColor`,
    )};
  overflow: hidden;
`;

const PackageOption = ({
  disabled,
  children,
  selected,
  title,
  onClickCTA,
  isBestAvailableRate = false,
  pillText,
}: PackageOptionProps) => (
  <PackageOptionCard selected={selected} pillText={pillText}>
    <StyledBox
      minHeight={['502px', null, '546px']}
      bg="background.card"
      boxShadow="elevation8"
      selected={selected}
      data-testid="PACKAGE_OPTION"
      width={['100%', null, '390px']}
    >
      <Flex flexDirection="column" flex={1} justifyContent="space-between">
        <Box>
          <PackageOptionHeading
            title={title}
            isBestAvailableRate={isBestAvailableRate}
          />
          <PackageOptionContent>
            <Flex flexDirection="column" gap={['4px', null, '8px']} pt={4}>
              {children}
            </Flex>
          </PackageOptionContent>
        </Box>
        {!selected && (
          <PackageOptionContent>
            <Button
              variant="primary"
              outline={true}
              data-testid="PACKAGE_OPTION_CTA"
              block
              disabled={disabled}
              rounded={true}
              onClick={onClickCTA}
              mb={'24px'}
            >
              Select package
            </Button>
          </PackageOptionContent>
        )}
      </Flex>
    </StyledBox>
  </PackageOptionCard>
);

export default PackageOption;
